import { useQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { validate as isValidUUID } from 'uuid';

import { backendApiSignSupportsFindOneOptions } from '@/modules/api/@tanstack/react-query.gen';

export const useSignSupportQuery = () => {
  const paramsSignSupportId = useParams({
    strict: false,
    select: (params) => params.signSupportId,
  });

  return useQuery({
    ...backendApiSignSupportsFindOneOptions({ path: { signSupportId: paramsSignSupportId as string } }),
    enabled: isValidUUID(paramsSignSupportId),
  });
};
